// @flow
import React from 'react'
import Alert from 'reactstrap/lib/Alert'

type PopoverProps = {
  type?: string,
  text: string,
}

const Popover = (props: PopoverProps) => {
  return (
    <Alert color={props.type || 'info'}>
      {props.text}
    </Alert>
  )
}

export default Popover
